module.exports = __webpack_public_path__ + "static/img/102080.2f4f8000.png";